import { executePost } from '../common/apiCaller'
import { PostUserAccountInputDto } from '../dto/userAccountDto'

const apiName = 'public'
const apiPath = '/user-account'

export const executePostUserAccount = (input: PostUserAccountInputDto) => {
  return executePost<null>(apiName, apiPath, input)
}
